import { render } from "./ModalBackground.vue?vue&type=template&id=2cd16f27&scoped=true"
import script from "./ModalBackground.vue?vue&type=script&lang=js"
export * from "./ModalBackground.vue?vue&type=script&lang=js"

import "./ModalBackground.vue?vue&type=style&index=0&id=2cd16f27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd16f27"]])

export default __exports__